<!-- eslint-disable prettier/prettier -->
<template>
  <div class="order-page" v-loading="state.loading">
    <div class="header-nav">
      <button class="back-btn" @click="handleBack"><img :src="require('@/assets/images/back.png')" alt="返回"></button>
      <div class="nav-title">提交订单</div>
    </div>
    <div class="content-wrapper">
      <div class="header card">
        <div class="row between head-row">
          <div class="title">{{ model.Mc || '门票' }}</div>
        </div>
        <div class="sub">{{ model.PlMc }} · {{ model.GysMc }}</div>
        <div class="meta" v-if="model.Mdd || model.Dz">
          <span class="label">地址</span>
          <span class="val">{{ (model.Mdd || '-') + (model.Dz ? ('，' + model.Dz) : '') }}</span>
        </div>
        <div class="meta" v-if="model.Dh">
          <span class="label">电话</span>
          <span class="val">{{ model.Dh }}</span>
        </div>
      </div>

      <div class="section card contact-section">
        <div class="contact-info">
          <div class="required-field">
            <span class="required-mark">*</span>
            <label class="contact-label">手机：</label>
            <el-input v-model="state.Yklxrsj" placeholder="请输入联系人手机号" style="height: 50px; font-size: 18px;" :validate-event="false" />
          </div>
          <div v-if="state.phoneError" class="error-message">{{ state.phoneError }}</div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">选择日期</div>
        <el-date-picker
          v-model="state.date"
          type="date"
          :clearable="false"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          :disabled-date="disabledPast"
          style="width: 100%"
          @change="loadDetail"
        />
      </div>

      <div class="section card" v-if="(model.Tcs||[]).length">
        <div class="section-title">选择套餐</div>
        <div class="tc-list">
          <div class="tc-item" v-for="tc in model.Tcs" :key="tc.Id">
            <div class="tc-head">
              <div class="tc-name">{{ tc.Mc }}</div>
              <div class="tc-price">
                <span class="old" v-if="tc.Scdj">￥{{ $priceFormat(tc.Scdj) }}</span>
                <span class="new">￥{{ $priceFormat(tc.Xsdj) }}</span>
                <span class="unit">/{{ tc.Dw }}</span>
              </div>
            </div>
            <div class="tc-meta">
              <span v-if="tc.Drxss && tc.Drxss>0">每日限购{{ tc.Drxss }}{{ tc.Dw }}</span>
              <span v-else>不限购</span>
              <span v-if="tc.Syrq">｜使用日期：{{ tc.Syrq }}</span>
              <span v-if="tc.Kc >= 0">｜库存：{{ tc.Kc }}</span>
              <span v-if="tc.Sm">｜{{ tc.Sm }}</span>
            </div>
            <div class="tc-actions">
              <span class="label">数量</span>
              <el-input-number
                v-model="tc.Sl"
                :min="0"
                :max="tc.Drxss === -1 ? 999 : (tc.Drxss || 999)"
                @change="onQtyChange"
                size="small"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="section card empty" v-else>
        暂无可售套餐
      </div>

      <div class="section card" v-for="tc in state.selected" :key="tc.Id">
        <div class="section-title">{{ tc.Mc }} ({{ tc.Sl }}位游客)</div>
        <div v-for="(yk, index) in state.tourists[tc.Id]" :key="index" class="yk-item">
          <el-input v-model="yk.Xm" placeholder="姓名" />
          <el-input v-model="yk.Sfzh" placeholder="身份证号" />
          <el-input v-model="yk.Sjhm" placeholder="手机号" />
        </div>
      </div>

      <div class="section card" v-if="model.Xz">
        <div class="section-title row between">
          <span>预定须知</span>
          <el-button link type="primary" @click="state.xzOpen = !state.xzOpen">{{ state.xzOpen ? '收起' : '展开' }}</el-button>
        </div>
        <div v-show="state.xzOpen" class="xz" v-html="model.Xz" />
      </div>

       <div class="section card">
        <div class="section-title">联系人信息</div>
        <div class="contact-info">
          <div class="required-field">
            <el-input v-model="state.Yklxrxm" placeholder="请输入联系人姓名" style="margin-bottom: 10px;" />
          </div>
          <div v-if="state.nameError" class="error-message">{{ state.nameError }}</div>
        </div>
      </div>

      <div class="section card">
        <div class="section-title">订单备注</div>
        <el-input v-model="state.Bz" type="textarea" :autosize="{minRows: 2}" placeholder="可填写出游说明等" />
      </div>
      
      <!-- 添加底部空间，确保内容不被固定的footer遮挡 -->
      <div class="bottom-space"></div>
    </div>

    <div class="footer">
      <div class="price">
        <div class="total">总价￥{{ $priceFormat(totalPrice) }}</div>
      </div>
      <el-button type="primary" class="submit" @click="onSubmit">提交订单</el-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable prettier/prettier */
import { reactive, computed, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { dayjs,ElMessage } from 'element-plus'
import { shangpin_xddetailAny, shangpindingdan_addany } from '@/http/api'

export default {
  setup() {
    const route = useRoute()
    const router = useRouter()
    const query = reactive({});

    const handleBack = () => {
      router.go(-1);
    }

    const state = reactive({
      loading: false,
      date: dayjs().format('YYYY-MM-DD'),
      Bz: '',
      xzOpen: true,
      selected: [],
      tourists: {},
      Yklxrxm: '', // 联系人姓名
      Yklxrsj: '',  // 联系方式
      nameError: '', // 联系人姓名错误信息
      phoneError: '' // 手机号验证错误信息
    })
    const model = reactive({})

    const disabledPast = (d) => dayjs(d) < dayjs(dayjs().format('YYYY-MM-DD 00:00:00'))

    const loadDetail = () => {
      state.loading = true
      shangpin_xddetailAny(route.params.id, { date: state.date,ph:query.ph,_t:query._t }).then(res => {
        if (res.status === 200) {
          Object.assign(model, res.data)
          // 初始化套餐数量为0
          ;(model.Tcs||[]).forEach(t=>{ if(typeof t.Sl!=='number') t.Sl = 0 })
          onQtyChange()
        }
      }).finally(() => state.loading = false)
    }

    const totalPrice = computed(() => (state.selected || []).reduce((s, m)=> s + m.Sl * (m.Xsdj||0), 0))

    const onQtyChange = () => {
      state.selected = (model.Tcs||[]).filter(t=>t.Sl>0)
      // 为每个套餐初始化游客信息数组
      state.selected.forEach(tc => {
        if (!state.tourists[tc.Id]) {
          state.tourists[tc.Id] = []
        }
        // 确保游客数量与选择数量一致
        while (state.tourists[tc.Id].length < tc.Sl) {
          state.tourists[tc.Id].push({ Xm: '', Sfzh: '', Sjhm: '' })
        }
        while (state.tourists[tc.Id].length > tc.Sl) {
          state.tourists[tc.Id].pop()
        }
      })
      // 清除已取消选择套餐的游客信息
      Object.keys(state.tourists).forEach(id => {
        if (!state.selected.some(tc => tc.Id == id)) {
          delete state.tourists[id]
        }
      })
    }

    const onSubmit = () => {
      // 验证联系人姓名为必填
      //if (!state.Yklxrxm) {
        //state.nameError = '请输入联系人姓名'
        //return
      //}
      
      // 验证联系方式为必填
      if (!state.Yklxrsj) {
        state.phoneError = '请输入联系人手机号'
        return
      }
      
      // 验证手机号格式
      const phoneRegex = /^1[3-9]\d{9}$/
      if (state.Yklxrsj && !phoneRegex.test(state.Yklxrsj)) {
        state.phoneError = '请输入正确的手机号格式'
        return
      }
      
      // 验证通过，清除错误信息
      state.nameError = ''
      state.phoneError = ''
      
      if (!state.selected?.length) {
        ElMessage.warning('请至少选择一张票')
        return
      }
      const mx = state.selected.map(t=>({
        Id: t.Id,
        Mc: t.Mc,
        Xsdj: t.Xsdj || 0,
        Sl: t.Sl,
        Syrq: dayjs(state.date).format('YYYY-MM-DD 00:00:00')
      }))
      const data = {
        KhId: null,
        Syrq: dayjs(state.date).format('YYYY-MM-DD 00:00:00'),
        Mxs: mx,
        Bz: state.Bz,
        Yklxrxm: state.Yklxrxm||'', // 联系人姓名
        Yklxrsj: state.Yklxrsj||'',  // 联系人手机号
        Sl:0,
        Xsyj:0,
        Xsj:0,
        // 添加游客信息
        Ykxx: state.selected.flatMap(tc => {
          return state.tourists[tc.Id].map((yk, index) => ({
            SpTcId: tc.Id,
            Xm: yk.Xm,
            Zjh: yk.Sfzh,
            Zjlx:"身份证",
            Sjhm: yk.Sjhm,
            Xh: index + 1,
          }))
        })
      }

      state.selected.flatMap(tc => {
          data.Xsj+=tc.Xsdj*tc.Sl;
        })

      var userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.match(/Alipay/i) == "alipay") {
          // alert("支付宝浏览器");
          state.type = "A_JSAPI";
        } else if (userAgent.match(/MicroMessenger/i) == "micromessenger") {
          state.type = "T_JSAPI";
        }
      else
         ElMessage.warning("请使用微信或支付宝扫码！");

      shangpindingdan_addany(data,query.ph,query._t).then(res => {
        if (res.status === 200) {
          if (state.type == "T_JSAPI") {
            /* const redirect_uri = encodeURIComponent(
              "http://shwl.cs.ebsys.cn/#/h5/payment/"+res.data.Id+"?ph=" + query.ph+"&_t="+query._t
            ); */
            const redirect_uri = encodeURIComponent(
              "http://shwl.cs.ebsys.cn/#/hf/wx?dh=" + res.data.Bh+"&ph=" + query.ph+"&_t="+query._t
            ); 
            const redirect_uri1 =
              "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx00280cfc822fb27a&redirect_uri=" +
              redirect_uri +
              "&response_type=code&scope=snsapi_base#wechat_redirect";
              window.location=redirect_uri1
            }
          else if(state.type=="A_JSAPI")
          {
               router.push({
              name: 'ZhiFuBao',
              params: { },
              query: { ph: query.ph, _t: query._t, dh: res.data.Bh }
            }) 
          }
        }
      })
    }

    watch(() => model.Tcs, () => onQtyChange(), { deep: true })

    onMounted(() =>{ 
      query.ph = route.query.ph; 
      query._t = route.query._t;  
      loadDetail()
    })

    return { state, model, loadDetail, onSubmit, totalPrice, disabledPast, handleBack }
  }
}
</script>

<style>
.header-nav {
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.back-btn {
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  left: 15px;
  width: 20px;
  height: 20px;
  padding: 0;
}

.back-btn img {
  width: 100%;
  height: 100%;
}
.nav-title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.order-page {
  padding: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
}

.content-wrapper {
  padding: 12px;
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* 苹果设备上平滑滚动 */
}

.card {
  background: #fff;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,.03);
}

.header .title {
  font-weight: 700;
  font-size: 18px;
}

.header .sub {
  color: #909399;
  margin-top: 4px;
}

.header .meta {
  margin-top: 6px;
  font-size: 12px;
  color: #606266;
}

.header .label {
  color: #909399;
  margin-right: 4px;
}

.section {
  margin-top: 10px;
}

.section-title {
  font-weight: 600;
  margin-bottom: 8px;
}

.row {
  display: flex;
  align-items: center;
}

.between {
  justify-content: space-between;
}

.yk-item {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
  margin-bottom: 8px;
}

.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: #fff;
  box-shadow: 0 -4px 10px rgba(0,0,0,.04);
  z-index: 1000;
}

.footer .total {
  color: #f00;
  font-weight: 700;
}

.footer .submit {
  flex: 1;
}

.tc-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tc-item {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 10px;
}

.tc-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tc-name {
  font-weight: 600;
}

.tc-price .old {
  color: #909399;
  text-decoration: line-through;
  margin-right: 6px;
}

.tc-price .new {
  color: #f00;
  font-weight: 700;
}

.tc-price .unit {
  color: #909399;
  margin-left: 2px;
}

.tc-meta {
  color: #909399;
  font-size: 12px;
  margin-top: 6px;
}

.tc-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
}

.xz {
  color: #606266;
  font-size: 13px;
}

.empty {
  color: #909399;
  text-align: center;
}

/* 底部空间，确保内容不被固定的footer遮挡 */
.bottom-space {
  height: 80px;
}

/* 滚动条样式优化 */
.content-wrapper::-webkit-scrollbar {
  width: 4px;
}

.content-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.content-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
}

.content-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.2);
}

/* 错误提示样式 */
.required-field {
  display: flex;
  align-items: center;
}

.required-mark {
  color: #f56c6c;
  margin-right: 4px;
  line-height: 1;
  font-size: 18px;
}

.error-message {
  color: #f56c6c;
  font-size: 14px;
  line-height: 1;
  padding-top: 4px;
}

/* 联系人信息样式优化 */


.contact-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
  text-align: center;
  color: #fff;
}

.contact-info .el-input__wrapper {
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.95);
  border: none;
}

.contact-info .el-input__inner {
  background-color: transparent;
  border: none;
  outline: none;
}

/* 增强标题视觉效果 */
.contact-title {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
  color: #fff;
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
  letter-spacing: 1px;
}

/* 联系人信息标签样式 */
.contact-label {
  font-size: 16px;
  font-weight: 600;

  margin-right: 10px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  height: 50px;
}
</style>


